(function () {
  const FREE_SHIPPING_THRESHOLD = 100; // USD
  const DEBUG_MODE = false;

  let cartRefreshTimeout = null;
  let isFetchingCart = false;

  function debugLog(msg, data = null) {
    if (DEBUG_MODE) console.log(`[Free Shipping]: ${msg}`, data || '');
  }

  function formatCurrency(cents) {
    const format = window.shopMoneyFormat || '${{amount}}';
    const placeholder = /\{\{\s*(amount(_no_decimals)?(_with_comma_separator)?)\s*\}\}/;

    function formatWithDelimiters(num, precision, thousands = ',', decimal = '.') {
      if (isNaN(num) || num == null) return 0;
      num = (num / 100).toFixed(precision);
      const parts = num.split('.');
      const dollars = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, thousands);
      const cents = parts[1] ? decimal + parts[1] : '';
      return dollars + cents;
    }

    const key = format.match(placeholder)?.[1];
    let value;

    switch (key) {
      case 'amount':
        value = formatWithDelimiters(cents, 2);
        break;
      case 'amount_no_decimals':
        value = formatWithDelimiters(cents, 0);
        break;
      case 'amount_with_comma_separator':
        value = formatWithDelimiters(cents, 2, '.', ',');
        break;
      case 'amount_no_decimals_with_comma_separator':
        value = formatWithDelimiters(cents, 0, '.', ',');
        break;
      default:
        value = (cents / 100).toFixed(2);
    }

    return format.replace(placeholder, value);
  }

  function updateShippingProgress(cart) {
    if (!cart || !cart.total_price) return;

    const rate = parseFloat(window?.Shopify?.currency?.rate || 1);
    const totalLocal = cart.total_price / 100;
    const totalUSD = totalLocal / rate;

    const progress = Math.min((totalUSD / FREE_SHIPPING_THRESHOLD) * 100, 100);
    const remainingUSD = Math.max(FREE_SHIPPING_THRESHOLD - totalUSD, 0);
    const remainingLocal = remainingUSD * rate;
    const isCompleted = totalUSD >= FREE_SHIPPING_THRESHOLD;

    const container = document.querySelector('.shipping-progress-container');
    const message = document.querySelector('.free-shipping-message');
    const label = document.querySelector('.shipping-progress-label');

    if (!container || !message || !label) {
      debugLog('Shipping bar elements missing');
      return;
    }

    container.style.backgroundImage = `linear-gradient(to right, #E54821 ${progress}%, #FFDDD4 ${progress}%)`;

    if (!container.classList.contains('animate')) {
      container.classList.add('animate');
      setTimeout(() => container.classList.remove('animate'), 600);
    }

    label.textContent = isCompleted
      ? '✅ Free Shipping unlocked!'
      : `🚚 ${Math.round(progress)}% toward Free Shipping`;

    message.innerHTML = isCompleted
      ? `<p>🎉 Congratulations! You've unlocked <strong>Free Shipping</strong>!</p>`
      : `<p>Add <strong>${formatCurrency(Math.round(remainingLocal * 100))}</strong> more to unlock <strong>Free Shipping</strong>!</p>`;

    debugLog('Progress updated', { progress, totalUSD });
  }

  function waitForBarAndUpdate(cart) {
    let attempts = 0;
    const max = 10;

    const check = setInterval(() => {
      const ready =
        document.querySelector('.shipping-progress-container') &&
        document.querySelector('.free-shipping-message') &&
        document.querySelector('.shipping-progress-label');

      if (ready || attempts >= max) {
        clearInterval(check);
        if (ready) updateShippingProgress(cart);
      }

      attempts++;
    }, 100);
  }

  function refreshCartData() {
    if (isFetchingCart) {
      debugLog('Cart fetch skipped (already running)');
      return;
    }

    isFetchingCart = true;

    fetch('/cart.js', {
      method: 'GET',
      headers: {
        'Content-Type': 'application/json',
        'X-Requested-With': 'XMLHttpRequest'
      }
    })
      .then(res => (res.ok ? res.json() : Promise.reject(res.status)))
      .then(cart => waitForBarAndUpdate(cart))
      .catch(err => {
        console.error('Cart fetch error', err);
        if (window.Shopify?.cart) updateShippingProgress(window.Shopify.cart);
      })
      .finally(() => {
        isFetchingCart = false;
      });
  }

  function debouncedRefreshCart(delay = 400) {
    if (cartRefreshTimeout) clearTimeout(cartRefreshTimeout);
    cartRefreshTimeout = setTimeout(refreshCartData, delay);
  }

  function observeCartDrawer() {
    const cartDrawer = document.querySelector('cart-drawer, #CartDrawer, .cart-drawer');
    if (!cartDrawer) return;

    const observer = new MutationObserver(() => {
      if (isFetchingCart) return;
      debouncedRefreshCart(600);
    });

    observer.observe(cartDrawer, { childList: true, subtree: true });
  }

  function setupListeners() {
    document.addEventListener('cart:updated', e => {
      if (e.detail?.cart) updateShippingProgress(e.detail.cart);
      else debouncedRefreshCart();
    });

    document.addEventListener('cart:refresh', () => debouncedRefreshCart());
    document.addEventListener('cart_update', () => debouncedRefreshCart());

    document.addEventListener('change', e => {
      if (e.target?.classList.contains('quantity__input')) {
        debouncedRefreshCart(300);
      }
    });

    document.addEventListener('click', e => {
      if (
        e.target?.closest('.cart-remove-button') ||
        e.target?.closest('.quantity__button')
      ) {
        debouncedRefreshCart(300);
      }
    });

    document.addEventListener('submit', e => {
      if (
        e.target?.action?.includes('/cart/add') ||
        e.target?.querySelector('[name="add"]')
      ) {
        debouncedRefreshCart(500);
      }
    });

    if (window.Shopify?.onCartUpdate) {
      const original = window.Shopify.onCartUpdate;
      window.Shopify.onCartUpdate = function (cart) {
        if (typeof original === 'function') original(cart);
        updateShippingProgress(cart);
      };
    }
  }

  function init() {
    setupListeners();
    observeCartDrawer();
    debouncedRefreshCart(400);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
